import React, { FC } from 'react';
import { useAxios } from '../hooks/useAxios';

export const AxiosProvider: FC = ({ children }) => {
  useAxios();
  return <>{children}</>;
};
